<page-heading [title]="'report.home.pageTitle' | translate" [description]="'report.home.pageDescription' | translate" />

@if (loadingContent) {
<content-loading-list />
}

<div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-2">
  @for (report of reports; track $index) {
  @if (!(report.hideInProd)) {
  <div class="col">
    <div class="card report-pill position-relative rounded" (click)="report.action()">
      <div class="card-body p-2">
        <div class="icon-tile mb-2">
          <i class="{{ report.icon }}"></i>
        </div>

        <h2 class="fs-5 text-dark mb-0">
          {{ report.title }}
        </h2>

        <a class="stretched-link" tabindex="-1"></a>
      </div>
    </div>
  </div>
  }
  }
</div>
